









import { Component, Vue } from 'vue-property-decorator'
import Nav from "@/components/navbar/index.vue";

@Component({
  name: 'Page404',
  components: {
    Nav
  }
})
export default class extends Vue {

}
